<template>
    <div class="satisfaction">
        <h1 v-if="!isLoading">
            {{ $t('satisfaction.title') }}
            <ReglePastille cle="satisfaction.definition" />
            <ReglePastille cle="satisfaction.visibiliteMenu" />
            <ReglePastille cle="satisfaction.choixSociete" />
        </h1>
        <p v-if="!isLoading && getSocietes.length > 1">
            {{ $t('satisfaction.choix.societe.titre') }}
        </p>

        <div v-if="!isLoading && getSocietes.length > 1">
            <DropDown
                :list="getSocietes"
                :selectedItem="societeSelectionnee"
                :display="displaySociete"
                @select="setSocieteSelectionnee"
                class="drop-down"
                :label="$t('satisfaction.choix.societe.input')"/>
        </div>

        <p v-if='societeSelectionnee != undefined'>{{ $t('satisfaction.description') }}</p>

        <LoaderComponent v-if="isLoading" />


        <div class="smileys" v-if='societeSelectionnee != undefined'>
            <img src="@/assets/img/unhappy.png" alt="Pas content" @click="handleClick(1)" />
            <img src="@/assets/img/neutral.png" alt="Neutre" @click="handleClick(2)" />
            <img src="@/assets/img/happy.png" alt="Content" @click="handleClick(3)" />
            <ReglePastille cle="satisfaction.parcoursSelonNote" />
        </div>

        <router-view></router-view>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { SATISFACTION } from '@/modules/Satisfaction/store/mutation-types';
import DropDown from '@/components/ui-components/DropDown.vue';
import AccountService from '@/modules/Account/services/AccountService';
import SatisfactionService from '@/modules/Satisfaction/services/SatisfactionService';
import { SatisfactionDTO } from '@/models/Satisfaction';
import { useStore } from 'vuex';
import LoaderComponent from '@/components/ui-components/LoaderComponent.vue';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'Satisfaction',
    components: { LoaderComponent,  DropDown, ReglePastille },
    data() {
        return {
            isLoading : false,
            societeSelectionnee: undefined,
        } ;
    },
    setup() {
        const store = useStore();
        const router = useRouter();

        const handleClick = (value: number) => {
            const satisfactionDTO: SatisfactionDTO = store.getters['satisfactionState/getSatisfaction'];
            let fin;
            if (value === 2) {
                fin = '/5';
            } else {
                fin = '/4';
            }
            satisfactionDTO.numeroQuestionSaisie = '1' + fin;
            SatisfactionService.updateSatisfaction(satisfactionDTO);
            router.push({ name: 'QuestionPage', params: { note: value, step: 1 } });
        };
        return {
            handleClick,
        };
    },
    async beforeMount() {
        this.isLoading = true;

        await AccountService.getSocieteIds(true).then((societes: any) => {

            this.$store.commit(`satisfactionState/${SATISFACTION.SET_SOCIETES}`, societes.data);
            this.isLoading = false;

        });
        if (this.getSocietes.length === 1) {
            this.$store.commit(`satisfactionState/${SATISFACTION.SET_SOCIETE_SELECTIONNEE}`, this.getSocietes[0].id);
            this.societeSelectionnee = this.getSocietes[0];
        }
        const satisfactionDTO = await SatisfactionService.getSatisfactionConditions();
        this.$store.commit(`satisfactionState/${SATISFACTION.SET_SATISFACTION}`, satisfactionDTO);
        satisfactionDTO.numeroQuestionSaisie = '0';
        await SatisfactionService.updateSatisfaction(satisfactionDTO);
    },
    methods: {
        setSocieteSelectionnee(item: any): void {
            this.societeSelectionnee = item;
            this.$store.commit(`satisfactionState/${SATISFACTION.SET_SOCIETE_SELECTIONNEE}`, item.id);
        },
        displaySociete(item: any): string {
            return item.libelle;
        }
    },
    computed: {
        getSocietes() {
            return this.$store.getters['satisfactionState/getSocietes'];
        }
    }
});
</script>

<style scoped>
.satisfaction {
    height: 100vh;
    text-align: center;
    padding: 20px;
    background-color: #f9f9f9;
}
.satisfaction h1 {
    font-size: 24px;
    margin-bottom: 10px;
}
.satisfaction p {
    font-size: 16px;
    margin-bottom: 20px;
}
.smileys {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 60px;
    margin-top: 100px;
}
.smileys img {
    width: 150px;
    cursor: pointer;
}
.drop-down{
    width: 40%;
    margin: auto auto 5vh;
}
</style>
